import React from 'react';
import styles from './Footer.module.css';

const Footer: React.FC = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.content}>
        <p className={styles.text}>
          深圳智驱者科技有限公司 © 2025 <span className={styles.dot}>·</span>
          <a 
            href="https://beian.miit.gov.cn" 
            target="_blank" 
            rel="noopener noreferrer" 
            className={styles.link}
          >
            粤ICP备2025413121号
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer; 